<script>
export default {
  name: 'DeleteProjectDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: [
    'cancelDeletion',
    'deleteProject',
  ],
  data () {
    return {
      showDialog: false,
    }
  },
  watch: {
    show (newValue) {
      this.showDialog = newValue
    },
  },
  methods: {
    onDeleteProject () {
      this.$emit('deleteProject')
    },
    onCancelDeletion () {
      this.$emit('cancelDeletion')
    },
  },
}
</script>
<template>
  <v-dialog
    v-model="showDialog"
    width="25%"
    persistent
  >
    <v-card>
      <v-card-title>
        {{ $gettext('Delete a project') }}
      </v-card-title>
      <v-card-text>
        {{ $gettext('Are you sure to delete this project?') }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          size="small"
          variant="elevated"
          color="secondary"
          :text="$gettext('Cancel')"
          @click="onCancelDeletion"
        />
        <v-btn
          size="small"
          variant="elevated"
          color="primary"
          :text="$gettext('Delete')"
          @click="onDeleteProject"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
